import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

interface ShowCCBCCButtonsProps {
  showCcInput: boolean;
  showBccInput: boolean;
  onToggleCc: () => void;
  onToggleBcc: () => void;
}

const ShowCCBCCButtons = ({
  showCcInput,
  showBccInput,
  onToggleCc,
  onToggleBcc,
}: ShowCCBCCButtonsProps) => {
  return (
    <Flex gap='sm' className='w-full -my-1' justify='end'>
      <button
        type='button'
        onClick={onToggleCc}
        className='underline underline-offset-2 hover:cursor-pointer'
      >
        <Typography
          variant='body-xs'
          textColor='muted'
          className='hover:text-neutral-900'
        >
          {showCcInput ? 'Hide Cc' : 'Cc'}
        </Typography>
      </button>
      <button
        type='button'
        onClick={onToggleBcc}
        className='underline underline-offset-2 hover:cursor-pointer'
      >
        <Typography
          variant='body-xs'
          textColor='muted'
          className='hover:text-neutral-900'
        >
          {showBccInput ? 'Hide Bcc' : 'Bcc'}
        </Typography>
      </button>
    </Flex>
  );
};

export default ShowCCBCCButtons;
